
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/identity/culture",
      function () {
        return require("private-next-pages/identity/culture.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/identity/culture"])
      });
    }
  